import { MARQUEE_ITEMS } from "@/lib/site-content";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="marquee"
      className="bg-zinc-900 text-white py-4 overflow-hidden border-y border-zinc-800"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-6 px-6 shrink-0">
            <span className="font-display font-bold text-sm uppercase tracking-[0.25em]">
              {it}
            </span>
            <span className="w-1.5 h-1.5 bg-[#FF4500] rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
